import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AdminRouting } from './admin.routing';

import { GestaoSsService } from '../shared/services/gestao-ss.service';
import { AuthGuard } from '../shared/authentication/auth-guard';
import { AuthService } from './auth.service';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { EmpregoNaPistaSharedModule } from '../shared/emprego-na-pista-shared.module';

import { LoginComponent } from './login/login.component';
import { AdminComponent } from './admin/admin.component';
import { TrocarPerfilComponent } from './trocar-perfil/trocar-perfil.component';

@NgModule({
    imports: [ BrowserModule, AdminRouting, ReactiveFormsModule, FormsModule, EmpregoNaPistaSharedModule],
    providers: [ GestaoSsService, AuthGuard, AuthService ],
    declarations: [ LoginComponent, AdminComponent, TrocarPerfilComponent ]
})
export class AdminModule { }



// WEBPACK FOOTER //
// ./src/app/components/admin/admin.module.ts